import { render, staticRenderFns } from "./When.vue?vue&type=template&id=48e55d20&scoped=true&"
import script from "./When.vue?vue&type=script&lang=js&"
export * from "./When.vue?vue&type=script&lang=js&"
import style0 from "./When.vue?vue&type=style&index=0&id=48e55d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e55d20",
  null
  
)

export default component.exports